import {Aepp} from '@aeternity/aepp-sdk';
import Config from '../Config/Config';

const getClient=async()=> {
  try {
    let client = await Aepp({parent:window.parent});
    let contractInstance = await client.getContractInstance(Config.contractSource, { contractAddress: Config.contractAddress });
    return  contractInstance;
  } catch (err) {
    console.error(err);
  }
}

export default getClient;



// WEBPACK FOOTER //
// ./src/HelperFiles/AeClient.js